import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {LoadingComponent} from './components/loading/loading.component';
import {FileDownloadComponent} from './components/file_download/file_download.component';
import { ActionButtonsComponent} from './components/smart-table/action-buttons/action-buttons.component';

import { OwlDateTimeModule, OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import {OwlMomentDateTimeModule} from 'ng-pick-datetime-moment';

import {FileDownloadService} from './components/file_download/file_download.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {NgxSelectModule} from 'ngx-select-ex';
import { TrueFalseValueDirective } from './directives/true-false-value.directive';
import { MonthPickerComponent } from './components/month-picker/month-picker.component';
import { ObjNgForPipe } from './pipes/obj-ng-for.pipe';
import { BeautyJsonPipe} from './pipes/beauty-json.pipe';
import { SelectPortalLangComponent } from './components/select-portal-lang/select-portal-lang.component';
import {MiscelaneaService} from './services/miscelanea.service';
import { FlagPipe } from './pipes/flag.pipe';
import { PillsPipe } from './pipes/pills.pipe';
import { PaginationComponent } from './components/pagination/pagination.component';
import { FilterPipe} from './pipes/filter.pipe';
import { SelectServiceProvidersComponent} from './components/select-service-providers/select-service-providers.component';
import { SelectCurrenciesComponent } from './components/select-currencies/select-currencies.component';
import { VarsAssocComponent } from './components/vars-assoc/vars-assoc.component';
import { TickCellComponent } from './components/smart-table/tick-cell/tick-cell.component';
import { FlagCellComponent } from './components/smart-table/flag-cell/flag-cell.component';
import { DefaultPipe } from './pipes/default.pipe';
import { SearchTextComponent } from './components/search-text/search-text.component';
import { AuxiliarService} from './services/auxiliar.service';
import {AlertaService} from './services/alerta.service';
import { ChopPipe } from './pipes/chop.pipe';
import { FilterLengthPipe } from './pipes/filter-length.pipe';
import { SelectVnaClientComponent } from './components/select-vna-client/select-vna-client.component';
import { ActionsDateListComponent } from './components/actions-date-list/actions-date-list.component';
import {ActionsService} from './services/actions.service';



import { ActionHistoryService} from './components/action-history/action-history.service';
import { SelectVnaServiceComponent} from '../phone/config/vna_services/components/select-vna-service/select-vna-service.component';
import { EditActionHistoryModalComponent } from './components/modals/edit-action-history-modal/edit-action-history-modal.component';
import {LocalCacheStorageService} from './services/local-cache-storage.service';
import { SelectVnaVarsComponent } from './components/select-vna-vars/select-vna-vars.component';
import { SelectVnaClientMultipleComponent } from './components/select-vna-client-multiple/select-vna-client-multiple.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

export const MY_MOMENT_FORMATS = {
    parseInput: 'l LT',
    fullPickerInput: 'YYYY-MM-DD HH:mm:ss',
    datePickerInput: 'l',
    timePickerInput: 'LT',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
};

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgxSelectModule,
        OwlDateTimeModule,
        OwlMomentDateTimeModule,
        NgMultiSelectDropDownModule.forRoot(),
    ],
    exports: [
        LoadingComponent,
        FileDownloadComponent,
        MonthPickerComponent,
        SelectPortalLangComponent,
        FormsModule,
        ActionButtonsComponent,
        PaginationComponent,
        TickCellComponent,
        FlagCellComponent,
        ReactiveFormsModule,
        TrueFalseValueDirective,
        ObjNgForPipe,
        FlagPipe,
        PillsPipe,
        BeautyJsonPipe,
        FilterPipe,
        SelectServiceProvidersComponent,
        SelectCurrenciesComponent,
        VarsAssocComponent,
        DefaultPipe,
        SearchTextComponent,
        ChopPipe,
        FilterLengthPipe,
        SelectVnaClientComponent,
        SelectVnaClientMultipleComponent,
        SelectVnaServiceComponent,
        SelectVnaVarsComponent
    ],
    providers: [
        FileDownloadService,
        MiscelaneaService,
        AuxiliarService,
        AlertaService,
        ActionsService,
        ActionHistoryService,
        LocalCacheStorageService,
        {provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS}
    ],

    declarations: [
        LoadingComponent,
        FileDownloadComponent,
        TrueFalseValueDirective,
        MonthPickerComponent,
        BeautyJsonPipe,
        FilterPipe,
        ObjNgForPipe,
        SelectPortalLangComponent,
        ActionButtonsComponent,
        FlagPipe,
        PillsPipe,
        PaginationComponent,
        SelectServiceProvidersComponent,
        SelectCurrenciesComponent,
        VarsAssocComponent,
        TickCellComponent,
        FlagCellComponent,
        DefaultPipe,
        SearchTextComponent,
        ChopPipe,
        FilterLengthPipe,
        SelectVnaClientComponent,
        ActionsDateListComponent,
        SelectVnaServiceComponent,
        EditActionHistoryModalComponent,
        SelectVnaVarsComponent,
        SelectVnaClientMultipleComponent
    ],

    entryComponents:[
        ActionButtonsComponent,
        TickCellComponent,
        FlagCellComponent,
        ActionsDateListComponent,
        EditActionHistoryModalComponent,
    ],
})

export class SharedModule {
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/shared.module.ts